import { Snackbar } from "@mui/material";
import React from "react";
import { withUserName } from "../../../utils/utils";

// Seven screens confirmed an action by rendering the server's message in a
// top-centre Snackbar, with the same props copy-pasted each time — and only one
// of them centred the text. This is that Snackbar, once.
//
// It also strips any bare row id the server left in the message. Callers that
// know WHO was acted on should still run withUserName(message, name) first, so
// the id becomes a name rather than disappearing; this is the safety net for
// the screens that have no row to name.

export interface ServerMessageSnackbarProps {
  open: boolean;
  /** The server's message, shown verbatim apart from id stripping. */
  message: string;
  onClose: () => void;
}

// The screens had drifted to 5s, 6s and 10s. Aligned on the training screen's
// 6s: long enough to read a confirmation, short enough not to sit over the
// header while you work.
const AUTO_HIDE_MS = 6000;

const ServerMessageSnackbar = ({ open, message, onClose }: ServerMessageSnackbarProps) => (
  <Snackbar
    open={open}
    message={withUserName(message)}
    onClose={onClose}
    autoHideDuration={AUTO_HIDE_MS}
    anchorOrigin={{ vertical: "top", horizontal: "center" }}
    key="topcenter"
    ContentProps={{
      sx: {
        "& .MuiSnackbarContent-message": { textAlign: "center", width: "100%" },
      },
    }}
  />
);

export default ServerMessageSnackbar;
